import { emojiIndex } from 'emoji-mart';

export function isValidEmoji(emojiId) {
  if (!emojiId || !emojiId.trim()) return false;
  const possibleEmojis = emojiIndex.search(emojiId);
  return !!possibleEmojis.find((emoji) => emoji.id === emojiId);
}
